export default ({ app }, inject) => {
    inject('isSweden', isSweden);
    inject('isNorway', isNorway);

    inject('formatBoolean', (boolean) => {
        return boolean
            ? app.$translate('yes', 'Ja') 
            : app.$translate('no', 'Nej');
    });    

    inject('getPaymentLogo', getPaymentLogo);
    inject('getPaymentLogoHtml', getPaymentLogoHtml);

    inject('formatPrismicImage', formatPrismicImage);
};

const getPrismicLang = () => {
    return process.env.PRISMIC_LANG;
};

const isSweden = () => {
    return getPrismicLang() === 'sv-se';
};
const isNorway = () => {
    return getPrismicLang() === 'no';
};

const getPaymentLogo = (payment) => {
    const logos = {
        visa: '/payments/visa-logo.png',
        mastercard: '/payments/mastercard-logo.png',
        amex: '/payments/amex-logo.png',
    };
    return logos[payment] 
        ? { 
            image: logos[payment], 
            alt: `${payment} logo` 
        } 
        : null;
};

const getPaymentLogoHtml = (payment, width = 35) => {
    const logo = getPaymentLogo(payment);
    if (!logo) {
        return null;
    }
    return `<img 
        src="${logo.image}" 
        alt="${logo.alt}" 
        class="payment-network-logo" 
        width="${width}"
        loading="lazy"
    >`;
};

const restoreRectAxisValues = (image) => {
    const { edit, dimensions } = image;
    if (!edit || !dimensions || !edit.zoom || edit.zoom <= 0) return null;

    // dimensions is the output size; dividing by zoom gives the crop size in source pixels.
    // edit.x/y are panning offsets in output-pixel space: negative y means panned up → crop starts lower → positive rect_y.
    const w = Math.round(dimensions.width / edit.zoom);
    const h = Math.round(dimensions.height / edit.zoom);
    const x = Math.max(0, Math.round(-edit.x / edit.zoom));
    const y = Math.max(0, Math.round(-edit.y / edit.zoom));

    return { x, y, w, h };
};


const replaceCorruptedFromPrismicImage = (image) => {
    if (!image || !image.url) {
        return image;
    }
    const url = new URL(image.url);
    const rect = url.searchParams.get('rect');

    if (rect) {
        const [x, y] = rect.split(',').map(Number);
        if (x < 0 || y < 0) {
            const restored = restoreRectAxisValues(image);
            if (restored) {
                url.searchParams.set('rect', `${restored.x},${restored.y},${restored.w},${restored.h}`);
            } 
            else {
                url.searchParams.set('rect', `${Math.max(0, x)},${Math.max(0, y)},1080,715`);
            }
        }
    }

    return {
        ...image,
        url: url.toString(),
    };
};

const formatPrismicImage = (image) => {
    // During migration cropped images got corrupted rect values (eg. negative values, which is bad) so we replace with a default value we know works.
    return replaceCorruptedFromPrismicImage(image);
};